import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Badges } from './badges.model';

export interface BadgesState extends EntityState<Badges> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'badges', idKey: 'ScorecardId' })
export class BadgesStore extends EntityStore<BadgesState> {
  constructor() {
    super();
  }
}
